import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { useLanguage } from '../i18n/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="inicio" className="relative pt-24 pb-4 md:pt-32 md:pb-6 overflow-hidden" data-id="element-180">
      <div className="container mx-auto px-4 md:px-6" data-id="element-181">
        {/* Banner with animated luminous aura */}
        <div className="relative max-w-6xl mx-auto mb-16" data-id="element-182">
          {/* Animated gold auras (sit behind the image) */}
          <div className="banner-glow-aura-1" aria-hidden="true" data-id="element-183" />
          <div className="banner-glow-aura-2" aria-hidden="true" data-id="element-184" />

          {/* Banner image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          ease: 'easeOut'
        }} className="relative w-full rounded-sm overflow-hidden shadow-2xl shadow-riam-gold/20" data-id="element-185">
            <img src="https://cdn.magicpatterns.com/uploads/ak85GV4ZeQoCc5YgRxs6SS/BANNER_RIAM.png" alt="Riam Beauty Studio Banner" className="w-full h-auto object-cover" data-id="element-186" />
            <div className="absolute inset-0 bg-gradient-to-t from-riam-black via-transparent to-transparent opacity-40" data-id="element-187"></div>
          </motion.div>
        </div>

        {/* Hero Content */}
        <div className="max-w-4xl mx-auto text-center" data-id="element-188">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="gold-shine font-script font-semibold md:text-6xl lg:text-7xl mb-6 tracking-tight text-[42px]" data-id="element-189">
            {t.hero.title1}
            <span className="font-allura font-normal text-6xl md:text-7xl lg:text-8xl align-middle mr-2 pr-1" data-id="element-190">
              {t.hero.titleHighlight}
            </span>{' '}
            {t.hero.title2}
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="font-sans font-normal text-lg md:text-xl text-riam-gold-light/80 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-191">
            {t.hero.subtitle1}
            <span className="font-allura font-normal text-3xl md:text-4xl align-middle mx-1 text-riam-gold" data-id="element-192">
              {t.hero.subtitleHighlight}
            </span>{' '}
            {t.hero.subtitle2}
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.7
        }} className="flex flex-col items-center space-y-4" data-id="element-193">
            <Button href="https://beautybyriam.booksy.com" className="w-full sm:w-auto font-sans font-semibold tracking-wider" data-id="element-194">
              {t.hero.cta}
            </Button>
            <p className="gold-shine-soft text-sm font-sans font-medium tracking-widest uppercase mt-4" data-id="element-195">
              {t.hero.socialProof}
            </p>
            <p className="font-allura text-3xl md:text-4xl text-riam-gold/60 mt-8 pt-4" data-id="element-196">
              Riam Beauty Studio
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}